export interface BidPackOriginRegion {
  Id: number;
  CountryId: number;
  SelectedCrossingCountryIds: number[];
  SupplierGsdb: string;
  ZipArea: string;
  ZipCode: string;
}

export const defaultBidPackOriginRegion: BidPackOriginRegion = {
  Id: 0,
  CountryId: 0,
  SelectedCrossingCountryIds: [],
  SupplierGsdb: "",
  ZipArea: "",
  ZipCode: "",
};
